import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import { logout } from "../auth/authSlice";
import { AcceptExtensionApi, AcceptLinkApi, AcceptOfferApi, AcceptSubmitWorkApi, AddReviewApi, AskAdjustmentApi, GetChatListApi, getCurrentStageOfChat, GetMessagesListApi, GetPendingCollaborationsCount, GetUnreadMessageCountApi, MakePaymentBrand, markSingleChatAsReadApi, RejectExtensionApi, RejectLinkApi, RejectOfferApi, ReportIssueApi, SendCustomOfferApi, SubmitAppealApi, SubmitExtensionApi, SubmitLinkApi, SubmitWorkApi } from "actions/chatActions";
import { STAGE_OFFER_ACCEPTED } from "constants/constants";


const initialState = {
  pendingRequestCount: 0,
  unReadMessagesCount: [],
  showOfferNow: false,
  loadingChats: false,
  loadingMessages: false,
  messageList: [],
  chatList: [],
  error: null,
  success: false,
  // Working Variables of Chat:
  currentUser: null,
  // currentUser:
  //   localStorage.getItem("user") === undefined
  //     ? null
  //     : JSON.parse(localStorage.getItem("user")),
  currentChatId: -1,
  receiverId: "",
  reportIssueTime: "",
  currentOffer: {},
  adjustmentId: "",
  submittedWork: "",
  currentStage: {},
  sender: {},
  receiver: {},
  offer: {},
  totalMessagePages: 0,
  currentPage: 1,
  // Pagination Variables:
  nextPageMessageUrl: "",
  fromMPage: "",
  lastMPage: "",
  // States of Chat below here:
  inviteRequestAccepted: false,
  workInProcess: false,
  deliveryTimeBar: false,
  acceptOffer: false,
  packBought: false,
  workSent: false,
  workReceived: false,
  workReceivedAgain: false,
  proofSent: false,
  proofReceived: false,
  proofReceivedAgain: false,
  proofAccepted: false,
  proofRejected: false,
  issueReported: false,
  customOfferSent: false,
  customOfferReceived: false,
  chatRequestSent: false,
  chatRequestReceived: false,
  changeRequestReceived: false,
  workSubmitSentAgain: false,
  appealRequest: false,
  //
  decisionInMyFav: false,
  decisionInCreatorFav: false,
  decisionInBrandFav: false,
  //
  decisionInMyFavResolved: false,
  decisionInCreatorFavResolved: false,
  decisionInBrandFavResolved: false,
  //
  paymentProcessed: false,
  extensionRequestReceived: false,
  reviewIsGiven: false,
  brandFavourDecision: false,
  workAccepted: false,
  workAccept: false,
  // Loading Variables
  loadingAcceptOffer: false,
  loadingRejectOffer: false,
  loadingBrandPayment: false,
  workLoading: false,
  extensionReqRej: false,
  extensionReqRejSuccess: false,
  customOfferError: false,
  submitExtensionError: false,
  submitLinkError: false,
  askAdjustmentError: false,
  extensionReqAccept: false,
  extensionReqAcceptSuccess: false,
  isLateDelivery: false,
  //
  brandCanReleasePaymentToCreator: false
};

const chatSlice = createSlice({
  name: "chats",
  initialState,
  reducers: {
    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },
    setCurrentChatId: (state, action) => {
      state.currentChatId = action.payload;
    },
    handleChatStages: (state) => {

      console.log(">>>>> state.currentStage.type:", JSON.parse(JSON.stringify(state.currentStage.type)));
      console.log(">>>>> state.offer:", JSON.parse(JSON.stringify(state.offer)));


      if (
        state.offer.payment_transaction && state.offer.payment_transaction.status == "pending"
      ) {
        state.brandCanReleasePaymentToCreator = true;
      }

      const setDeliveryStatus = (state, endTimeField, extraFields = {}) => {
        const startTime = Date.now();
        const endTime = new Date(endTimeField);

        let remainingTime = endTime - startTime;
        state.isLateDelivery = remainingTime < 0;
        state.deliveryTimeBar = true;

        // merge các field bổ sung nếu có
        Object.assign(state, extraFields);
      };

      chatSlice.caseReducers.resetStates(state);
      if (state.currentStage.type === "Chat Request Accepted") {
        state.chatRequestSent = false;
        state.acceptOffer = true;
      } else if (
        state.currentStage.type === STAGE_OFFER_ACCEPTED &&
        state.offer.payment_transaction === null
      ) {
        state.inviteRequestAccepted = true;
      }
      // else if (
      //   state.currentStage.type === STAGE_OFFER_ACCEPTED &&
      //   state.offer.payment_transaction && state.offer.payment_transaction.status == "pending"
      // ) {
      //   state.brandCanReleasePaymentToCreator = true;
      //   //
      //   setDeliveryStatus(state, state.offer.delivery_time);
      // }
      else if (
        state.currentStage.type.includes("Payment has been received") &&
        state.offer.payment_transaction
      ) {
        // Payment has been received from band test by VITRINE
        setDeliveryStatus(state, state.offer.delivery_time);
      } else if (
        state.currentStage.type === STAGE_OFFER_ACCEPTED ||
        state.currentStage.type === "Extension Requested Rejected" ||
        state.currentStage.type === "Extension Request Accepted" ||
        state.currentStage.type === "Extension Requested Accepted"
      ) {
        setDeliveryStatus(state, state.offer.delivery_time);
      } else if (state.currentStage.type === "Your pack bought" || state.currentStage.type === "Pack bought") {
        setDeliveryStatus(state, state.offer.delivery_time);
        // state.deliveryTimeBar = true;
        state.packBought = true;
      } else if (state.currentStage.type === "Chat Request Received") {
        state.chatRequestReceived = true;
      } else if (state.currentStage.type === "Chat Request Sent") {
        state.chatRequestSent = true;
      } else if (state.currentStage.type === "Payment successfull by brand") {
        state.deliveryTimeBar = true;
        state.workInProcess = true;
      } else if (state.currentStage.type === "Work Submission Sent") {
        state.workSent = true;
      } else if (state.currentStage.type === "Work Submission Received") {
        state.workReceived = true;
      } else if (state.currentStage.type === "Link Submission Request Sent") {
        state.proofSent = true;
      } else if (
        state.currentStage.type === "Link Submission Request Received"
      ) {
        state.proofReceived = true;
      } else if (
        state.currentStage.type === "Link Submission Request Received Again"
      ) {
        state.proofReceivedAgain = true;
      } else if (state.currentStage.type === "Proof Accepted") {
        state.proofAccepted = true;
      } else if (state.currentStage.type === "Proof Rejected" || state.currentStage.type === "Proof Rejected Again") {
        //
        state.proofRejected = true;
      } else if (state.currentStage.type === "Issue Reported For Proof") {
        state.issueReported = true;
      } else if (state.currentStage.type === "Customized Offer Sent") {
        state.customOfferSent = true;
      } else if (state.currentStage.type === "Customized Offer Received") {
        state.customOfferReceived = true;
      } else if (state.currentStage.type === "Work Change Request Received") {
        state.changeRequestReceived = true;
        state.adjustmentId = state.currentStage.adjustment_id;
      } else if (state.currentStage.type === "Work Submission Received Again") {
        state.workReceivedAgain = true;
      } else if (state.currentStage.type === "Work Submission Sent Again") {
        state.workSubmitSentAgain = true;
      } else if (state.currentStage.type === "Appeal Request") {
        state.appealRequest = true;
      } else if (state.currentStage.type === "Decision made in your favor") {
        state.decisionInMyFav = true;
      } else if (
        state.currentStage.type === "Decision made in favor of Brand" || state.currentStage.type === "Report decision made in favor of brand"
      ) {
        state.decisionInBrandFav = true;
      }
      else if (
        state.currentStage.type === "Payment Processed, Collaboration Completed"
        ||
        state.currentStage.type === "Payment Released to Creator"
      ) {
        state.paymentProcessed = true;
        state.brandCanReleasePaymentToCreator = false;
      } else if (
        state.currentStage.type === "Decision made in favor of Creator" || state.currentStage.type === "Report decision made in favor of creator"
      ) {
        state.decisionInCreatorFav = true;
      }
      else if (state.currentStage.type === "Decision made in your favor — payment has been processed") {
        state.decisionInMyFavPaymentProcessed = true;
      }
      else if (state.currentStage.type === "Decision made in favor of Brand — payment has been processed") {
        state.decisionInBrandFavPaymentProcessed = true;
      }
      else if (state.currentStage.type === "Decision made in favor of Creator — payment has been processed") {
        state.decisionInCreatorFavPaymentProcessed = true;
      }
      else if (
        state.currentStage.type === "Extension Requested Received"
      ) {
        state.extensionRequestReceived = true;
      } else if (state.currentStage.type === "Work Submission Accepted") {
        if (state.currentUser?.role === "1") {
          state.workAccept = true;
        }
      } else if (state.currentStage.type === "Review received") {
        if (state?.currentStage?.collaboration_reviews?.length === 2) {
          state.bothHaveGivenReviews = true;
        }
        state.reviewIsReceived = true;
      } else if (state.currentStage.type === "Review added") {
        if (state?.currentStage?.collaboration_reviews?.length === 2) {
          state.bothHaveGivenReviews = true;
        }
        state.reviewIsGiven = true;
      }
    },
    setTotalUnreadMessagesCount: (state, action) => {
      if (state.pendingRequestCount > 0) {
        state.pendingRequestCount = state.pendingRequestCount - 1;
      }
    },
    addMessage: (state, action) => {
      // Push the new message into the messageList when the message is SENT
      state.messageList.push({
        id: action.payload.id,
        sender_id: state.sender.id,
        receiver_id: state.receiver.id,
        message: action.payload.message,
        original_name: action.payload.original_name,
        file: action.payload.file,
        created_at: action.payload.created_at,
        updated_at: action.payload.updated_at,
        collaboration_id: action.payload.collaboration_id,
        offer_id: action.payload.offer_id,
        system_generated: action.payload.system_generated,
        sender: state.sender,
        receiver: state.receiver,
        type: action?.payload?.type
      });
      // Update the last message of the corresponding chat in chatList
      const chatIndex = state.chatList.findIndex(chat => chat.chat_id === action.payload.collaboration_id);
      if (chatIndex !== -1) {
        state.chatList[chatIndex].last_message = action.payload;
      }

    },
    // FOR RECEIVER WHEN SOCKET TRIGGERS AN EVENT
    updateChatAndMessage: (state, action) => {
      const payload = action?.payload?.data;
      if (!payload) return; // Exit early if payload is undefined/null

      const { currentUser, chatList, currentChatId } = state;
      const { system_generated, receiver_id, sender_id, message = "", collaboration_id } = payload;

      // Early exit if system-generated message has conflicting sender/receiver IDs
      if (system_generated === 1 && receiver_id === currentUser?.id && sender_id === currentUser?.id) return;

      const collaborationId = collaboration_id?.toString();
      const isSystemGenerated = system_generated?.toString() === "1";

      // Locate the relevant chat index
      const chatIndex = chatList?.findIndex(chat => chat.chat_id?.toString() === collaborationId);

      // Handle Invite Requests & Pack Purchases
      const isNewChatMessage = ["Invite request received", "has bought your pack"].some(msg => message?.includes(msg));

      if (isNewChatMessage) {
        const newChat = {
          user: { ...payload.sender },
          unread_message_count: 1,
          last_message: { ...payload, file: payload.file || payload.fileData },
          chat_id: collaboration_id,
        };

        // Insert at the start of chatList
        state.chatList = [newChat, ...chatList];
      }

      // Increment unread and pending request counts for specific messages
      const unreadMessageTypes = ["Invite request received", "Collaboration Accepted", "Collaboration Rejected"];
      if (unreadMessageTypes.includes(message)) {
        state.unReadMessagesCount += 1;
        if (message?.includes("Invite request")) state.pendingRequestCount += 1;
      }
      // Update existing chat if found
      if (chatIndex !== -1) {
        const chatToUpdate = chatList[chatIndex];
        chatToUpdate.last_message = { ...chatToUpdate.last_message, message, created_at: payload.created_at };
        if (collaboration_id !== currentChatId) {
          state.unReadMessagesCount += 1;
          chatToUpdate.unread_message_count += 1;
        }
      }
      // If the current chat is active, update messages and chat state
      if (currentChatId?.toString() === collaborationId) {
        if (isSystemGenerated) {
          state.currentStage = payload.chatFlow;
          state.offer = payload.offer;
        }
        // console.log("case 2", { state });
        chatSlice.caseReducers.handleChatStages(state);
        state.messageList.push({ ...payload, file: payload.file || null });
      }
    },

    updateMessageList: (state, action) => {
      state.messageList.unshift(...action.payload.data?.data?.data);
      state.currentPage = action?.payload?.data?.data?.current_page;
    },
    resetStates: (state, action) => {
      // state.totalMessagePages = 0;
      // state.currentPage = 0
      state.deliveryTimeBar = false;
      state.inviteRequestAccepted = false;
      state.workInProcess = false;
      state.acceptOffer = false;
      state.packBought = false;
      state.workSent = false;
      state.workReceived = false;
      state.workReceivedAgain = false;
      state.proofSent = false;
      state.proofReceived = false;
      state.proofReceivedAgain = false;

      state.proofAccepted = false;
      state.proofRejected = false;
      state.issueReported = false;
      state.customOfferSent = false;
      state.customOfferReceived = false;
      state.changeRequestReceived = false;
      state.workSubmitSentAgain = false;
      state.appealRequest = false;
      //
      state.decisionInMyFav = false;
      state.decisionInCreatorFav = false;
      state.decisionInBrandFav = false;
      //
      state.decisionInMyFavPaymentProcessed = false;
      state.decisionInCreatorFavPaymentProcessed = false;
      state.decisionInBrandFavPaymentProcessed = false;
      //
      state.paymentProcessed = false;

      state.extensionRequestReceived = false;
      state.reviewIsGiven = false;
      state.reviewIsReceived = false;
      state.bothHaveGivenReviews = false;

      state.brandFavourDecision = false;
      state.workAccepted = false;
      state.workAccept = false;
      state.chatRequestSent = false;
      state.chatRequestReceived = false;
      state.loadingAcceptOffer = false;
      state.loadingRejectOffer = false;

      state.loadingBrandPayment = false;
      // state.offer = {};
      state.extensionReqRej = false;
      state.extensionReqRejSuccess = false;
      state.submitExtensionError = false;
      state.askAdjustmentError = false;
      state.submitLinkError = false;

      state.extensionReqAccept = false;
      state.extensionReqAcceptSuccess = false;
      state.isLateDelivery = false;
    },
    resetCustomOfferError: (state, action) => {
      state.customOfferError = null;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(GetChatListApi.pending, (state, action) => {
        state.chatList = [];
        state.messageList = [];
        state.loadingChats = true;
        state.error = null;
      })
      .addCase(GetChatListApi.fulfilled, (state, action) => {
        console.log("action?.payload?.data?.data", action?.payload?.data?.data)

        let chatList = action?.payload?.data?.data;

        // Kiểm tra nếu chatList là một Object, chuyển nó thành Array
        if (Array.isArray(chatList)) {
          // Nếu đã là Array, tiến hành sắp xếp như bình thường
          const sortedChats = chatList.sort((a, b) => {
            const timestampA = new Date(a?.last_message?.created_at).getTime();
            const timestampB = new Date(b?.last_message?.created_at).getTime();
            return timestampB - timestampA;
          });

          state.loadingChats = false;
          state.chatList = sortedChats;
        } else if (chatList && typeof chatList === 'object') {
          // Nếu là Object, chuyển nó thành Array
          const sortedChats = Object.values(chatList).sort((a, b) => {
            const timestampA = new Date(a?.last_message?.created_at).getTime();
            const timestampB = new Date(b?.last_message?.created_at).getTime();
            return timestampB - timestampA;
          });

          state.loadingChats = false;
          state.chatList = sortedChats;
        } else {
          // Trường hợp không phải Array hoặc Object, có thể trả về một mảng rỗng hoặc thông báo lỗi.
          state.loadingChats = false;
          state.chatList = [];
        }
      })
      .addCase(GetChatListApi.rejected, (state, action) => {
        state.loadingChats = false;
        state.error = action;
      })
      .addCase(GetMessagesListApi.pending, (state, action) => {
        state.loadingMessages = true;
        state.error = null;
      })
      .addCase(GetMessagesListApi.fulfilled, (state, action) => {
        state.reportIssueTime = action?.payload?.data?.submitted_work?.report_issue_time;
        state.loadingMessages = false;
        state.currentStage = action?.payload?.data?.current_stage;
        state.offer = action?.payload?.data?.offer;
        state.currentPage = action?.payload?.data?.data?.current_page;
        state.totalMessagePages = action?.payload?.data?.data?.last_page;
        // Assigning the sender of the message here
        if (
          action?.payload?.data?.data?.data[0]?.sender_id.toString() ===
          state.currentUser.id.toString()
        ) {
          state.sender = action?.payload?.data?.data?.data[0]?.sender;
        } else {
          state.sender = action?.payload?.data?.data?.data[0]?.receiver;
        }
        // Assigning the receiver of the message here
        if (
          action.payload.data?.data?.data[0]?.sender_id.toString() ===
          state.currentUser.id.toString()
        ) {
          state.receiver = action?.payload?.data?.data?.data[0]?.receiver;
        } else {
          state.receiver = action?.payload?.data?.data?.data[0]?.sender;
        }
        // console.log("case 3", { state });
        chatSlice.caseReducers.handleChatStages(state);
        state.messageList = action?.payload?.data?.data?.data.reverse();
      })
      .addCase(GetMessagesListApi.rejected, (state, action) => {
        state.loadingMessages = false;
        state.error = action;
      })
      .addCase(MakePaymentBrand.pending, (state, action) => {
        state.loadingBrandPayment = true;
      })
      .addCase(MakePaymentBrand.fulfilled, (state, action) => {
        state.loadingBrandPayment = false;
      })
      .addCase(MakePaymentBrand.rejected, (state, action) => {
        state.loadingBrandPayment = false;
      })
      .addCase(AcceptOfferApi.pending, (state, action) => {
        state.loadingAcceptOffer = true;
        state.loadingBrandPayment = true;
      })
      .addCase(AcceptOfferApi.fulfilled, (state, action) => {
        state.loadingAcceptOffer = false;
        state.loadingBrandPayment = false;
      })
      .addCase(AcceptOfferApi.rejected, (state, action) => {
        state.loadingAcceptOffer = false;
        state.loadingBrandPayment = false;
      })
      .addCase(RejectOfferApi.pending, (state, action) => {
        state.loadingRejectOffer = true;
      })
      .addCase(RejectOfferApi.fulfilled, (state, action) => {
        state.loadingRejectOffer = false;
      })
      .addCase(RejectOfferApi.rejected, (state, action) => {
        state.loadingRejectOffer = false;
      })
      .addCase(SubmitWorkApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(SubmitWorkApi.fulfilled, (state, action) => {
        document.getElementById("submit-work-modal-close").click();
        state.workLoading = false;
        state.workSent = true;
      })
      .addCase(SubmitWorkApi.rejected, (state, action) => {
        state.workLoading = false;
        toast.error(action.payload?.message);
      })
      .addCase(AcceptSubmitWorkApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(AcceptSubmitWorkApi.fulfilled, (state, action) => {
        state.workLoading = false;
      })
      .addCase(AcceptSubmitWorkApi.rejected, (state, action) => {
        state.workLoading = false;
      })
      .addCase(AskAdjustmentApi.pending, (state, action) => {
        state.loadingAcceptOffer = true;
      })
      .addCase(AskAdjustmentApi.fulfilled, (state, action) => {
        state.loadingAcceptOffer = false;
        // document.getElementById("adjustment-modal-close")?.click();
      })
      .addCase(AskAdjustmentApi.rejected, (state, action) => {
        state.askAdjustmentError = action.payload;
        state.loadingAcceptOffer = false;
      })
      .addCase(SubmitLinkApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(SubmitLinkApi.fulfilled, (state, action) => {
        state.workLoading = false;
        document.getElementById("close-submit-link-modal")?.click();
      })
      .addCase(SubmitLinkApi.rejected, (state, action) => {
        state.submitLinkError = action?.payload?.errors;
        state.workLoading = false;
      })
      .addCase(AddReviewApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(AddReviewApi.fulfilled, (state, action) => {
        document.getElementById("review-modal-close")?.click();
        state.reviewIsGiven = true;
        state.workLoading = false;
      })
      .addCase(AddReviewApi.rejected, (state, action) => {
        state.workLoading = false;
      })
      .addCase(AcceptLinkApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(AcceptLinkApi.fulfilled, (state, action) => {
        state.workLoading = false;
      })
      .addCase(AcceptLinkApi.rejected, (state, action) => {
        state.workLoading = false;
      })
      .addCase(RejectLinkApi.pending, (state, action) => {
        state.loadingRejectOffer = true;
      })
      .addCase(RejectLinkApi.fulfilled, (state, action) => {
        state.loadingRejectOffer = false;
        document.getElementById("close-reject-submission-modal")?.click();
      })
      .addCase(RejectLinkApi.rejected, (state, action) => {
        state.loadingRejectOffer = false;
      })
      .addCase(ReportIssueApi.pending, (state, action) => {
        state.workLoading = true;
      })
      .addCase(ReportIssueApi.fulfilled, (state, action) => {
        state.workLoading = false;
        document.getElementById("close-report-modal").click();
      })
      .addCase(ReportIssueApi.rejected, (state, action) => {
        state.workLoading = false;
      })
      .addCase(AcceptExtensionApi.pending, (state, action) => {
        state.extensionReqAccept = true;
        state.loadingAcceptOffer = true;
      })
      .addCase(AcceptExtensionApi.fulfilled, (state, action) => {
        state.loadingAcceptOffer = false;
        state.extensionReqAccept = false;
        state.extensionReqAcceptSuccess = true;
        state.deliveryTimeBar = true;
        state.workInProcess = true;
      })
      .addCase(AcceptExtensionApi.rejected, (state, action) => {
        state.loadingAcceptOffer = false;
        state.extensionReqAccept = false;
        state.extensionReqAcceptSuccess = false;
      })
      .addCase(RejectExtensionApi.pending, (state, action) => {
        state.extensionReqRej = true;
        state.extensionReqRejSuccess = false;
        state.loadingRejectOffer = true;
      })
      .addCase(RejectExtensionApi.fulfilled, (state, action) => {
        state.loadingRejectOffer = false;
        state.extensionReqRej = false;
        state.extensionReqRejSuccess = true;
      })
      .addCase(RejectExtensionApi.rejected, (state, action) => {
        state.loadingRejectOffer = false;
        state.extensionReqRej = false;
        state.extensionReqRejSuccess = false;
      })
      .addCase(SubmitExtensionApi.pending, (state, action) => {
        state.loadingRejectOffer = true;
      })
      .addCase(SubmitExtensionApi.fulfilled, (state, action) => {
        document.getElementById("request-extension-modal-close").click();
        state.deliveryTimeBar = false;
        state.loadingRejectOffer = false;
      })
      .addCase(SubmitExtensionApi.rejected, (state, action) => {
        state.submitExtensionError = action?.payload?.error;
        state.loadingRejectOffer = false;
      })
      .addCase(SendCustomOfferApi.pending, (state, action) => {
        state.workLoading = true;
        state.customOfferError = null;
      })
      .addCase(SendCustomOfferApi.fulfilled, (state, action) => {
        state.workLoading = false;
        state.customOfferError = null;
        document.getElementById("custom-offer-modal-close")?.click();
      })
      .addCase(SendCustomOfferApi.rejected, (state, action) => {
        state.workLoading = false;
        state.customOfferError = action?.payload?.errors;
      })
      .addCase(SubmitAppealApi.pending, (state, action) => {
        state.loadingAcceptOffer = true;
      })
      .addCase(SubmitAppealApi.fulfilled, (state, action) => {
        document.getElementById("submit-appeal-modal-close")?.click();
        state.loadingAcceptOffer = false;
      })
      .addCase(SubmitAppealApi.rejected, (state, action) => {
        state.loadingAcceptOffer = false;
      })
      .addCase(GetUnreadMessageCountApi.fulfilled, (state, action) => {
        state.unReadMessagesCount = action?.payload?.data?.data;
      })
      .addCase(GetPendingCollaborationsCount.fulfilled, (state, action) => {
        state.pendingRequestCount = action?.payload?.data?.data;
      })
      .addCase(getCurrentStageOfChat.fulfilled, (state, action) => {
        state.reportIssueTime = action?.payload?.data?.latest_system_generated_message?.task_submission?.report_issue_time;
        state.currentStage = action?.payload?.data?.current_stage;
        state.offer = action?.payload?.data?.offer;
        if (!state.messageList.find((d) => d.id === action.payload?.data?.latest_system_generated_message?.id)) {
          state.messageList.push(
            action.payload?.data?.latest_system_generated_message
          );
        }
        // console.log("case 1", { state });
        chatSlice.caseReducers.handleChatStages(state);
      })
      .addCase(markSingleChatAsReadApi.fulfilled, (state, action) => {
        let index = state?.chatList?.findIndex((d) => d.chat_id === state.currentChatId);
        if (index > -1) {
          let numToMinus = state.chatList[index]?.unread_message_count;
          state.chatList[index].unread_message_count = 0;
          if (state.unReadMessagesCount > 0) {
            state.unReadMessagesCount -= numToMinus;

            if (state.unReadMessagesCount < 0) {
              console.warn(
                `[UnreadMessages] Count became negative (${state.unReadMessagesCount}), reset to 0`
              );
              state.unReadMessagesCount = 0;
            }
          }
        }
      })
      .addCase(logout, (state) => {
        return initialState;
      });
  },
});

export const {
  resetStates,
  addMessage,
  setCurrentUser,
  updateChatAndMessage,
  setCurrentChatId,
  setTotalUnreadMessagesCount,
  updateMessageList,
  resetCustomOfferError
} = chatSlice.actions;

export const loadingChats = (state) => state.loadingChats;
export const loadingMessages = (state) => state.loadingMessages;
export const messageList = (state) => state.messageList;
export const unReadMessagesCount = (state) => state.unReadMessagesCount;
export const pendingRequestCount = (state) => state.pendingRequestCount;


export const chatList = (state) => state.chatList;
export const error = (state) => state.error;
export const success = (state) => state.success;

// Working Chat Variables Exported:
export const currentChatId = (state) => state.currentChatId;
export const receiverId = (state) => state.receiverId;
export const currentOffer = (state) => state.currentOffer;
export const adjustmentId = (state) => state.adjustmentId;
export const submittedWork = (state) => state.submittedWork;
export const currentStage = (state) => state.currentStage;
export const offer = (state) => state.offer;

// Working Pagination Variables Exported:
export const nextPageMessageUrl = (state) => state.nextPageMessageUrl;
export const currentPage = (state) => state.currentPage;
export const totalMessagePages = (state) => state.totalMessagePages
export const fromMPage = (state) => state.fromMPage;
export const lastMPage = (state) => state.lastMPage;

// Chat States Exported:
export const inviteRequestAccepted = (state) => state.inviteRequestAccepted;
export const workInProcess = (state) => state.workInProcess;
export const deliveryTimeBar = (state) => state.deliveryTimeBar;
export const isLateDelivery = (state) => state.isLateDelivery;
export const acceptOffer = (state) => state.acceptOffer;
export const packBought = (state) => state.packBought;
export const workSent = (state) => state.workSent;
export const workReceived = (state) => state.workReceived;
export const workReceivedAgain = (state) => state.workReceivedAgain;
export const proofSent = (state) => state.proofSent;
export const proofReceived = (state) => state.proofReceived;
export const proofReceivedAgain = (state) => state.proofReceivedAgain;

export const proofAccepted = (state) => state.proofAccepted;
export const proofRejected = (state) => state.proofRejected;
export const issueReported = (state) => state.issueReported;
export const customOfferSent = (state) => state.customOfferSent;
export const customOfferReceived = (state) => state.customOfferReceived;
export const changeRequestReceived = (state) => state.changeRequestReceived;
export const workSubmitSentAgain = (state) => state.workSubmitSentAgain;
export const appealRequest = (state) => state.appealRequest;
//
export const decisionInMyFav = (state) => state.decisionInMyFav;
export const decisionInCreatorFav = (state) => state.decisionInCreatorFav;
export const decisionInBrandFav = (state) => state.decisionInBrandFav;
//
export const decisionInMyFavPaymentProcessed = (state) => state.decisionInMyFavPaymentProcessed;
export const decisionInCreatorFavPaymentProcessed = (state) => state.decisionInCreatorFavPaymentProcessed;
export const decisionInBrandFavPaymentProcessed = (state) => state.decisionInBrandFavPaymentProcessed;
//
export const paymentProcessed = (state) => state.paymentProcessed;

export const extensionRequestReceived = (state) =>
  state.extensionRequestReceived;
export const extensionReqAccept = (state) => state.extensionReqAccept;
export const extensionReqAcceptSuccess = (state) =>
  state.extensionReqAcceptSuccess;
export const extensionReqRej = (state) => state.extensionReqRej;
export const extensionReqRejSuccess = (state) => state.extensionReqRejSuccess;
export const submitExtensionError = (state) => state.submitExtensionError;
export const askAdjustmentError = (state) => state.askAdjustmentError;
export const customOfferError = (state) => state.customOfferError;


export const submitLinkError = (state) => state.submitLinkError;


export const reviewIsGiven = (state) => state.reviewIsGiven;
export const reviewIsReceived = (state) => state.reviewIsReceived;
export const bothHaveGivenReviews = (state) => state.bothHaveGivenReviews;


export const brandFavourDecision = (state) => state.brandFavourDecision;
export const workAccepted = (state) => state.workAccepted;
export const workAccept = (state) => state.workAccept;
export const reportIssueTime = (state) => state.reportIssueTime;
export const chatRequestSent = (state) => state.chatRequestSent;
export const chatRequestReceived = (state) => state.chatRequestReceived;

// Loading Variables Export:
export const loadingAcceptOffer = (state) => state.loadingAcceptOffer;
export const loadingRejectOffer = (state) => state.loadingRejectOffer;

export const loadingBrandPayment = (state) => state.loadingBrandPayment;

export const workLoading = (state) => state.workLoading;

export default chatSlice.reducer;
